const permissionsDev = [
  {
    _id: "6579b4731c63640013942364",
    permission: "Exercise Library",
  },
  {
    _id: "6579b4821c63640013942365",
    permission: "Widgets",
  },
  {
    _id: "6579b48c1c63640013942366",
    permission: "Templates",
  },
  {
    _id: "6579b4981c63640013942367",
    permission: "PRESS",
  },
  {
    _id: "6579b4a01c63640013942368",
    permission: "PUSH",
  },
  {
    _id: "6579b4a01c63640013942369",
    permission: "Custom Workflows",
  },
];

const permissionsProd = [
  {
    _id: "65c2450326aae50014b271f8",
    permission: "Exercise Library",
  },
  {
    _id: "65c244fa968bdb00135d847d",
    permission: "Widgets",
  },
  {
    _id: "65c244ee26aae50014b271f7",
    permission: "Templates",
  },
  {
    _id: "65c2450f26aae50014b271fa",
    permission: "PRESS",
  },
  {
    _id: "65c2451b26aae50014b271fb",
    permission: "PUSH",
  },
  {
    _id: "65c2451b26aae50014b271fc",
    permission: "Custom Workflows",
  },
];

const isNodeEnvProd = process.env.NODE_ENV === "production";

export const getOrganizationPermissions = () => {
  if (isNodeEnvProd) return permissionsProd;
  return permissionsDev;
};
